import React from 'react'
import'../components/Title.css'

function Title() {
    return (
        <div className= "title">
            <h1>Winstagram</h1>
            <h2>Your Pictures</h2>
            <p>Click on the button below to upload an image and description!</p>
        </div>
    )
}

export default Title
